// extracted by mini-css-extract-plugin
module.exports = {"dynamicContent":"az_Dlc","title":"az_Elc","label":"az_Flc"};